import { computed, Injectable, ViewContainerRef } from '@angular/core';
import { ComponentType } from '@angular/cdk/overlay';
import { sideBarTokenizer } from '../store';
import { SideBarThreadAnchor } from '../types';

@Injectable()
export class HandleSideBarService {
  private readonly _handleSideBarStore = sideBarTokenizer();

  $currentComponentRef = computed(() =>
    this._handleSideBarStore.$currentComponentRef(),
  );

  /** The component last requested, whether or not anything rendered it. */
  $requestedComponent = computed(() =>
    this._handleSideBarStore.$requestedComponent(),
  );

  $toggleSideBar = computed(() => this._handleSideBarStore.$toggleSideBar());

  $currentViewContainerRef = computed(() =>
    this._handleSideBarStore.$currentViewContainerRef(),
  );

  setVCR(vcr: ViewContainerRef): void {
    this._handleSideBarStore.setCurrentViewContainerRef(vcr);
  }

  /**
   * Requests a sidebar component; `anchor` (ERM-12196) names the conversation
   * the Collab Hub drawer should land on when it renders the request.
   */
  setSideBarComponent(
    component: ComponentType<unknown>,
    anchor?: SideBarThreadAnchor,
  ): void {
    this._handleSideBarStore.setCurrentViewContainerComponent(
      component,
      anchor,
    );
  }

  /**
   * @NOTE:- The following method will only clear currentComponentRef.
   */
  clearCurrentComponentRef(): void {
    this._handleSideBarStore.clearCurrentComponentRef();
  }

  /**
   * @NOTE: - The following method will clear both currentViewContainerRef and currentComponentRef
   */
  clearVCR(): void {
    this._handleSideBarStore.clearCurrentViewContainerRef();
  }

  setToggleSideBarOpen(isOpen: boolean): void {
    this._handleSideBarStore.toggleSideBarOpen(isOpen);
  }
}
